import { MERCHANT_OPERATIONS } from "@price-rescue/api-contracts";
import type {
  CatalogRepairBatchResult,
  CatalogRepairJobProgressDto,
} from "@price-rescue/api-contracts";
import type { MerchantApiClient } from "../../types.js";
import { freezeProductBulkSelection } from "./product-bulk-selection.js";

export interface CatalogRepairService {
  start(productIds: string[], idempotencyKey: string): Promise<CatalogRepairBatchResult>;
  getJob(jobId: string): Promise<CatalogRepairJobProgressDto>;
}
export function createCatalogRepairService(
  client: Pick<MerchantApiClient, "operation">,
): CatalogRepairService {
  return {
    async start(productIds, idempotencyKey) {
      const response = await client.operation<{ data: CatalogRepairBatchResult }>(
        MERCHANT_OPERATIONS.repairCatalogProducts,
        {
          body: { productIds: freezeProductBulkSelection(productIds) },
          request: { idempotencyKey },
        },
      );
      return response.data;
    },
    async getJob(jobId) {
      const response = await client.operation<{ data: CatalogRepairJobProgressDto }>(
        MERCHANT_OPERATIONS.getMerchantJobStatus,
        { pathParams: { jobId } },
      );
      return response.data;
    },
  };
}
